function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60,57.313A3.313,3.313,0,1,1,63.312,54,3.316,3.316,0,0,1,60,57.313Zm0-4.625A1.313,1.313,0,1,0,61.312,54,1.313,1.313,0,0,0,60,52.688Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M71,55H66.21a1,1,0,0,1,0-2H70V34.709L61.806,24H50V53h3.79a1,1,0,0,1,0,2H49a1,1,0,0,1-1-1V23a1,1,0,0,1,1-1H62.3a1,1,0,0,1,.794.392l8.7,11.37A1,1,0,0,1,72,34.37V54A1,1,0,0,1,71,55Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M49,55H24.42a1,1,0,0,1,0-2H48V16.99H4V53h8a1,1,0,0,1,0,2H3a1,1,0,0,1-1-1V15.99a1,1,0,0,1,1-1H49a1,1,0,0,1,1,1V54A1,1,0,0,1,49,55Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M49,44H3a1,1,0,0,1,0-2H49a1,1,0,0,1,0,2Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.208,61.208A7.208,7.208,0,1,1,25.417,54,7.216,7.216,0,0,1,18.208,61.208Zm0-12.417A5.208,5.208,0,1,0,23.417,54,5.214,5.214,0,0,0,18.208,48.792Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.208,57.208A3.208,3.208,0,1,1,21.417,54,3.212,3.212,0,0,1,18.208,57.208Zm0-4.417A1.208,1.208,0,1,0,19.417,54,1.21,1.21,0,0,0,18.208,52.792Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M60,61.208A7.208,7.208,0,1,1,67.208,54,7.216,7.216,0,0,1,60,61.208Zm0-12.417A5.208,5.208,0,1,0,65.208,54,5.214,5.214,0,0,0,60,48.792Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M65.17,41H54a1,1,0,0,1-1-1V28.83a1,1,0,0,1,1-1h6.91a1,1,0,0,1,.795.394l4.26,5.585a1,1,0,0,1,.205.606V40A1,1,0,0,1,65.17,41ZM55,39h9.17V34.753L60.415,29.83H55Z"
});

const SvgDeliveryTruck = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 74 74",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeliveryTruck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delivery-truck.e7b9a2bb.svg";
export { ForwardRef as ReactComponent };